import {
    KNOWLEDGE_DATA_LIST_RESPONSE,
    UNAUTHENTICATED
} from "../../actions/action-types"
import { extractEntitiesFromData } from "./entity-reducer-utils"

export default (state = {}, action) => {
    const { type, data } = action
    switch (type) {
        case KNOWLEDGE_DATA_LIST_RESPONSE:
            return extractEntitiesFromData(data, state)
        case UNAUTHENTICATED:
            return {}
        default:
            return state
    }
}
